import {Help} from './components/help';

export default {
    component: Help
};
